import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { stringify } from 'qs';
import router from 'umi/router';
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Tooltip,
  Modal,
  message,
  Cascader,
  Select,
  Popconfirm,
  Icon,
} from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import OperateDropdown from '../../../../../components/OperateDropdown';
import TreeSelectChannel from '../components/TreeSelectChannel';
import { getAppCode } from '../../utils/utils';
import { getPathHeader } from '../../../../../utils/utils';
import AdjustOrder from '../components/AdjustOrder'
import { convertData, getDefaultData, getLabelStrData } from '../../utils/convertData';
import styles from './index.less';

const { confirm } = Modal;

const { ListTable } = ListPage;
const { Option } = Select;

const topIcon = '//s.xiaoyuanhao.com/xiaoyuanhao/image/zhiding_icon.png';

@connect(({ user }) => {
  return {
    orgId: user.currentUser.orgId,
  };
})
class ArticleLists extends Component {

  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      channelList: [],
      loading: false,
      totalElements: 0,
      visible: false,
      selectChannelId: [],
      selectRcord: {},
      alreadyPushList: {},
      publicList: [],
      labelList: [],
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        channelId: '',
        upOrDownStatus: '',
        upOrDownType: 'down',
        newsTypes: '0,1',
      },
      channelId: '0',
      treeChannelData: [],
      setOrder: false,
      // userIdentity: 0,
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchChannelList();
    this.fetchLabelList();
    this.fetchPublishList(params);
    this.fetchAllConfigure();
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params, channelId } = this.state;
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          newsLabelId: values.newsLabelId ? encodeURIComponent(values.newsLabelId) : 0,
          channelId,
          upOrDownStatus: values.upOrDownStatus === 0 ? '' : values.upOrDownStatus,
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchPublishList(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params, channelId } = this.state;
    const tempParams = {
      ...params,
      title: '',
      channelId,
      upOrDownStatus: '',
      newsLabelId: 0,
      page: 1,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchPublishList(tempParams);
  };

  fetchPublishList = params => {
    const { dispatch } = this.props;
    const { alreadyPushList } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchPublishList',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res, alreadyPushList),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const data = [{ value: 0, label: '全部栏目', children: convertData(res || []) }];
        const channelList = convertData(res || []);
        channelList.unshift({ value: 0, label: '全部', children: [] });
        this.setState({
          channelList,
          treeChannelData: data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // 获取标签列表
  fetchLabelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchLabelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const arr = [];
        (res || []).forEach(item => {
          arr.push({ ...item, checked: false });
        });
        this.setState({ labelList: arr, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchNewsRemove = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchNewsRemove',
      params: { ids: record.id },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('撤下成功');
        const { params } = this.state;
        this.fetchPublishList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // 上报教育局
  handleUpEdu = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchUpToEdu',
      params: {
        id: record.id,
        appCode: getAppCode(),
      },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('上报成功');
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  confirmPush = record => {
    const that = this;
    confirm({
      title: '确定要给所有用户发送文章提醒吗？',
      content: '',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        that.fetchPushNews(record);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  fetchPushNews = record => {
    const { dispatch } = this.props;
    const { alreadyPushList, params } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchPushNews',
      params: { id: record.id, appCode: getAppCode() },
    })
      .then(() => {
        const obj = {};
        obj[record.id] = record.id;
        this.setState({ loading: false, alreadyPushList: { ...alreadyPushList, ...obj } }, () => {
          this.fetchPublishList(params);
        });
        message.success('推送成功');
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchAllConfigure = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'publicMass/fetchAllConfigure',
      params: {
        appCode: getAppCode(),
      },
    })
      .then(res => {
        this.setState({ loading: false, publicList: res || [] });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  toMicroToPublic = (type, isBatchPush) => {
    const { publicList = [] } = this.state;
    if (isBatchPush !== 'batchPush' && publicList.length <= 0) {
      message.error('暂未绑定公众号，请先网站设置-公众号设置处绑定');
    } else {
      router.push(`/${getPathHeader()}/publish/countyList/${type}?appCode=${getAppCode()}`);
    }
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 400,
        fixed: 'left',
        render: (text, record) => {
          if (text.length <= 20) {
            return (
              <span className="title-wrap">
                {record.stayonTop !== 0 && <img src={topIcon} alt="" />}
                <span>{text}</span>
              </span>
            );
          }
          return (
            <span className="title-wrap">
              {record.stayonTop !== 0 && <img src={topIcon} alt="" />}
              <Tooltip placement="top" title={text}>
                <span>{text.substring(0, 20)}...</span>
              </Tooltip>
            </span>
          );
        },
      },
      {
        title: '关联标签',
        dataIndex: 'labelList',
        key: 'labelList',
        width: 220,
        render: (text, record) => {
          const str = record.labelData && record.labelData.join(';');
          if (!str) {
            return <span>-</span>;
          }
          if (str.length <= 12) {
            return <span>{str}</span>;
          }
          return (
            <Tooltip placement="top" title={str}>
              <span>{str.substring(0, 12)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '文章类型',
        dataIndex: 'newstype',
        key: 'newstype',
        width: 150,
        render: text => {
          if (text === '0') {
            return <span>图文文章</span>;
          }
          return <span>外链文章</span>;
        },
      },
      {
        title: '发布时间',
        dataIndex: 'outputDate',
        key: 'outputDate',
        render: text => {
          return <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },
      {
        title: (
          <div>
            未阅/已阅
            <Tooltip placement="top" title="不需要进行消息推送提醒的资讯内容不统计阅读情况" autoAdjustOverflow>
              <Icon type="question-circle" style={{ marginLeft: 4 }} />
            </Tooltip>
          </div>
        ),
        key: 'read',
        width: 120,
        render: record => {
          const { readid, id, counted, noCounted, gray } = record;
          const obj = { readid, id, gray };
          return (
            <span style={{ color: '#1785EC' }} onClick={e => this.handleGoToReadDetail(obj, e)}>
              {readid ? `${noCounted} / ${counted}` : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          const data = [
            {
              text: (
                <a
                  onClick={e => {
                    e.stopPropagation();
                    router.push(
                      `/${getPathHeader()}/publish/countyList/edit?id=${record.id
                      }&appCode=${getAppCode()}&newstype=${record.newstype}&from=publish`
                    );
                  }}
                >
                  编辑
                </a>
              ),
            },
            {
              text: record.newsInfoExtend.upDownType !== '2' && (
                <a onClick={() => this.movement(record)}>移动</a>
              ),
            },
            {
              text: record.newsInfoExtend.upDownType !== '2' && (
                <a onClick={() => this.fetchNewsRemove(record)}>撤下</a>
              ),
            },
            {
              text: record.newsInfoExtend.upDownType !== '2' && (
                <Popconfirm
                  title="确认上报教育局?"
                  overlayStyle={{ zIndex: 1051 }}
                  onConfirm={() => this.handleUpEdu(record)}
                >
                  <a>上报教育局</a>
                </Popconfirm>
              ),
            },
          ];
          const newData = [];
          data.forEach(item => {
            if (item.text) {
              newData.push(item);
            }
          });
          return <OperateDropdown data={newData} />;
        },
      },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params, channelId } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
      channelId: channelId === '0' ? '' : channelId,
    };
    this.setState({ params: tempParams });
    this.fetchPublishList(tempParams);
  };

  movement = record => {
    const { channelList } = this.state;
    this.setState(
      {
        selectChannelId: getDefaultData(channelList, record.channel.id),
        selectRcord: record,
      },
      () => {
        this.setState({ visible: true });
      }
    );
  };

  handleOk = () => {
    const { selectChannelId, selectRcord } = this.state;

    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'artcleLists/fetchNewsMovement',
      params: {
        toChanneldId: selectChannelId[selectChannelId.length - 1],
        ids: selectRcord.id,
      },
    })
      .then(() => {
        this.setState({ loading: false, visible: false });
        const { params } = this.state;
        this.fetchPublishList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleChange = value => {
    this.setState({ selectChannelId: value });
  };

  // 跳转阅读组件详情
  handleGoToReadDetail = (obj, e) => {
    e.stopPropagation();
    const { orgId } = this.props;
    const { readid, id, gray } = obj;
    if (readid) {
      if (gray === 1) {
        router.push(
          `/readStatistics/readDetail?appId=${getAppCode()}&infoId=${id}&countId=2&parentId=${orgId}`
        );
      } else {
        router.push(
          `/${getPathHeader()}/publish/list/readDetail?${stringify({
            id,
            msgId: readid,
          })}`
        );
      }
    }
  };

  // 跳转详情
  handleGoToDetail = id => {
    router.push(
      `/${getPathHeader()}/publish/countyList/approvalDetail?id=${id}&appCode=${getAppCode()}`
    );
  };

  setChannelId = id => {
    const { params } = this.state;
    this.setState({ channelId: id, params: { ...params, page: 1 } });
  };


  refreshData = () => {
    const { params } = this.state;
    this.fetchPublishList(params);

  }

  render() {
    const {
      columns,
      loading,
      dataSource,
      params,
      totalElements,
      channelList = [],
      visible,
      selectChannelId,
      labelList,
      treeChannelData,
      setOrder,
      channelId,
    } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
    };


    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Row className={styles['search-area']}>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="文章标题">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item {...formItemLayout} label="标签">
                {getFieldDecorator('newsLabelId', {
                  initialValue: 0,
                })(
                  <Select>
                    <Option value={0}>全部</Option>
                    {labelList.map(item => {
                      return <Option value={item.id}>{item.label}</Option>;
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right', paddingRight: 24 }}>
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="create-button">
            <Button onClick={() => this.toMicroToPublic('batchPush', 'batchPush')} type="primary">
              推送
            </Button>

            {/* <Button
              style={{ marginLeft: 10 }}
              onClick={() => this.toMicroToPublic('batchPush', 'batchPush')}
            >
              按标签推送
              </Button> */}
            <Button style={{ marginLeft: 10 }} onClick={() => this.toMicroToPublic('publicMass')}>
              群发至公众号
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={() =>
                this.setState({ setOrder: true })
              }
            >
              调整顺序
            </Button>
          </section>
          <section className="table-area">
            <div>
              <TreeSelectChannel
                channelList={treeChannelData}
                params={params}
                fetchPublishList={this.fetchPublishList}
                setChannelId={this.setChannelId}
              />
            </div>
            <div>
              <ListTable {...tableProps} />
            </div>
          </section>
          <Modal
            title="移动到其他栏目"
            centered
            visible={visible}
            onOk={this.handleOk}
            onCancel={() => this.setState({ visible: false })}
          >
            <Cascader
              style={{ width: '100%' }}
              onChange={this.handleChange}
              options={channelList}
              defaultValue={selectChannelId}
              value={selectChannelId}
              placeholder="请选择发布的栏目"
            />
          </Modal>

          {
            setOrder && <AdjustOrder
              visible={setOrder}
              close={() => this.setState({ setOrder: false })}
              refreshData={this.refreshData}
              channelId={channelId}
            />

          }
        </ListPage>
      </Container>
    );
  }
}

const ArticleListsFrom = Form.create()(ArticleLists);
export default ArticleListsFrom;
